import { } from "../../node_modules/datatables.net/js/jquery.dataTables.min.js";
import { debounce } from "./debounce";

// html controls created in php
let elements = {
	$table: $('#resource-table'),
	$select_resource: $("#resource"),
	$select_brand: $("#brand"),
	$select_all: $("#selectAll"),
	$reveal: $(".resources__reveal-link"),
	$input_search: null, // gets set after datatable init
}

// javascript datatable object
let datatable = elements.$table.DataTable({
	pageLength: 25,
	dom: "frtpil",
	order: [
		[1, 'asc'],
		[0, 'asc'],
	],
	language: {
		search: "Filter",
		searchPlaceholder: "Text",
		lengthMenu: "Limit _MENU_",
	}
});
elements.$input_search = $("#resource-table_filter input");

// responsible for querystring creation for permalink and history states
function update_url() {
	let pieces = {
		resource: elements.$select_resource.val(),
		brand: elements.$select_brand.val(),
		filter: elements.$input_search.val(),
	};
	let params = new URLSearchParams(pieces);
	let querystring = "?" + params.toString();
	history.pushState(pieces, null, querystring);
}

// responsible for updating the html controls, parse querystring, set values and trigger
function update_controls() {
	let qs = new URLSearchParams(window.location.search);
	let resource = qs.get("resource") ?? qs.get("resources");
	let brand = qs.get("brand");
	let filter = qs.get("filter");

	elements.$select_resource.val(resource).trigger("change");
	elements.$select_brand.val(brand).trigger("change");
	elements.$input_search.val(filter).trigger("keyup");
}

// helper func to return the text value of a select. <option value='foo'>Return These Words</option>
function get_search_string(ele) {
	let value = $(ele).val();
	let text = $(":selected", ele).text();
	// default select options have no value, don't search for their text
	let strSearch = value ? text : "";
	return strSearch;
}

// set the functionality of the form selects, buttons, and inputs
function set_control_handlers() {
	// resource select
	elements.$select_resource.on("change", function (e) {
		datatable
			.columns(2)
			.search(get_search_string(this))
			.draw();
		if (e.originalEvent) {
			update_url();
		}
	});

	// brand select
	elements.$select_brand.on("change", function (e) {
		datatable
			.columns(1)
			.search(get_search_string(this))
			.draw();
		if (e.originalEvent) {
			update_url();
		}
	});

	// reset button
	elements.$select_all.on("click", function (e) {
		elements.$select_resource.val("").trigger("change");
		elements.$select_brand.val("").trigger("change");
		elements.$input_search.val("").trigger("keyup");
		if (e.originalEvent) {
			update_url();
		}
	});

	// datatable filter
	elements.$input_search.on("keydown", debounce(update_url));
}

// news and reviews has click + reveal functions for additional info
elements.$reveal.on("click", function (e) {
	e.preventDefault();
	let $target = $(this).siblings(".resources__reveal-target");
	$target.toggleClass("is_open");
});


export function init() {
	set_control_handlers();
	update_controls();

	// back/forward button
	window.addEventListener('popstate', (event) => {
		update_controls();
	});
}
